import React from "react";
import privacyData from "../../../../common/assets/data/privacy";
import Section from "../../../utility/ui-components/section";
import Container from "../../../utility/ui-components/container";
function PrivacySection(props) {
  const data = props.content;
  window.scrollTo(0, 0);
  return (
    <>
      <Section>
        <Container>
          {data.map((item,index)=>(
            <div key={index+1}>
              <h1 className=" text-xl md:text-2xl font-bold mb-3">{item.SectionTitle}</h1>
              <h4 className="text-base md:text-xl font-bold mb-2">{item.SubHeading}</h4>
              {item.paragraph.map((listData,index)=>(
                <div key={index+1}>
                 {listData.paraHeading && 
                 <h6 className="text-base md:text-lg font-bold mb-2">{listData.paraHeading}</h6>
                 } 
                 {listData.data && <p className=" text-base md:text-lg mb-2">{listData.data}</p>}
                 <ul>
                  {listData.list.map((listItems,index)=>(
                    <li className="text-base md:text-lg mb-2 md:mb-4">{listItems.item}</li>
                  ))}
                 </ul>
                  </div>

              ))}
            </div>
          ))}
        
        {/* <div className=" lg:grid lg:grid-cols-2 gap-16 items-center mx-auto max-w-screen-xl">
          <SectionHeading className="" heading={data.Heading} />
        </div>
        <div className="container">
          <p className="mb-4 text-lg">{data.paragraph.data1}</p>
          <p className="mb-4 text-lg">{data.paragraph.data2}</p>
        </div> */}
        </Container>
      </Section>
    </>
  );
}

export default PrivacySection;
